import type { Table } from '@tanstack/react-table'

import { X } from 'lucide-react'
import { Button } from '~/shadcn/ui/button/button'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import {
  getProjectLoanPurposeOptions,
  interestRateOptions,
  type FilterOptionValues,
} from '~/@mid_ui/table/tableFilterOptions'
import { MultiSelect } from '~/@pages_investing/projects/_projects_filtering/MultiSelect'
import type { ProjectCollateralSubcategory } from '~/@pages_investing/projects/_project_types/projectCollateralSubCategory'
import { CollateralSubcategorySelect } from '~/@pages_investing/projects/_projects_filtering/CollateralSubcategorySelect'
import type { Investment } from '../_investment_types/investment.types'
import { InvestmentDateFilters } from './investmentDateFilters'
import { investmentValueOptions } from './investmentTableFilterOptions'

type InvestmentsFiltersProps = { table: Table<Investment> }

function InvestmentsFilters({ table }: InvestmentsFiltersProps) {
  const isDesktop = useIsDesktop()

  const closeButton = (
    <Button
      variant="ghost"
      className="self-baseline lg:self-center p-2"
      onClick={() => table.setColumnFilters([])}>
      <X className="w-5 h-5" />
      <span className="ml-1 text-black-900">Resetovať filtre</span>
    </Button>
  )

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-row flex-wrap items-center gap-3">
        <MultiSelect
          colorScheme="light"
          label="Účel úveru"
          options={getProjectLoanPurposeOptions()}
          values={
            table
              .getColumn('project.loanPurpose')!
              .getFilterValue() as FilterOptionValues<
              ReturnType<typeof getProjectLoanPurposeOptions>
            >
          }
          onChange={table.getColumn('project.loanPurpose')!.setFilterValue}
        />
        <CollateralSubcategorySelect
          colorScheme="light"
          values={
            table
              .getColumn('project.collateralInfo.collateralSubcategory')!
              .getFilterValue() as Array<ProjectCollateralSubcategory>
          }
          onChange={
            table.getColumn('project.collateralInfo.collateralSubcategory')!
              .setFilterValue
          }
        />

        <MultiSelect
          colorScheme="light"
          label="Moja investícia"
          options={investmentValueOptions}
          values={
            table.getColumn('value')!.getFilterValue() as FilterOptionValues<
              typeof interestRateOptions
            >
          }
          onChange={table.getColumn('value')!.setFilterValue}
        />

        {/* TODO: tento filter nefunguje */}
        <MultiSelect
          colorScheme="light"
          label="Investícia s výnosom"
          options={investmentValueOptions}
          values={
            table
              .getColumn('totalPrincipalWithYieldValue')!
              .getFilterValue() as FilterOptionValues<
              typeof investmentValueOptions
            >
          }
          onChange={
            table.getColumn('totalPrincipalWithYieldValue')!.setFilterValue
          }
        />

        <InvestmentDateFilters table={table} />

        {isDesktop && closeButton}
      </div>
      {!isDesktop && closeButton}
    </div>
  )
}

export { InvestmentsFilters }
